import { getDataSession, LOCAL_STORAGE } from "helper/session";
import _ from "lodash";
import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router";
import PropTypes from "prop-types";
import {
  // ACTION,
  ACTION_ALLOW,
  KEY_ROLE_BIZZ_UAA,
  UAA_CHILDREN_PATH,
} from "./constant";
// try to fix chunk error
// const lazy = (componentImport) =>
//   lazyReact(async () => {
//     try {
//       const component = await componentImport();
//       return component;
//     } catch (error) {
//       return window.location.reload();
//     }
//   });

const PermissionForm = React.lazy(() =>
  import("@pageUAA/PermissionConfig/DetailPage")
);
const SystemManagementList = React.lazy(() =>
  import("@pageUAA/SystemManagement/ListPage")
);
const SystemManagementForm = React.lazy(() =>
  import("@pageUAA/SystemManagement/DetailPage")
);

const PermissionPage = React.lazy(() =>
  import("@pageUAA/PermissionConfig/ListPage")
);

const CreateUpdateUser = React.lazy(() => import("@pageUAA/CreateUpdateUser"));
const UserManagementPage = React.lazy(() => import("@pageUAA/UserManagement"));
const CompanyPermission = React.lazy(() =>
  import("@pageUAA/CompanyPermission")
);
const APIManagementList = React.lazy(() =>
  import("@pageUAA/APIManagement/ListPage")
);
const APIManagementCreate = React.lazy(() =>
  import("@pageUAA/APIManagement/DetailPage")
);
const ServiceManager = React.lazy(() => import("@pageUAA/Service"));
const ServiceCreateUpdate = React.lazy(() =>
  import("@pageUAA/ServiceCreateUpdate")
);
const FeatureManager = React.lazy(() => import("@pageUAA/Feature"));
const FeatureCreateUpdate = React.lazy(() =>
  import("@pageUAA/FeatureCreateUpdate")
);

const PrivateRoute = ({ children, roles }) => {
  const location = useLocation();
  const roleCurrent = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

  const { isAuthor, pmsAction } = useMemo(() => {
    if (_.isNil(roles))
      return {
        isAuthor: true,
        pmsAction: ACTION_ALLOW,
      };

    const { code: key } = Object(roleCurrent) || {};

    const ACTION = _.reduce(
      ACTION_ALLOW,
      function (result, value, key) {
        result[key] = false;
        return result;
      },
      {}
    );

    const pmsAction = _.assign(ACTION, _.get(roles, key));

    return {
      isAuthor: _.has(roles, key),
      pmsAction,
    };
  }, [roleCurrent]);

  const isAuthenticated = getDataSession(LOCAL_STORAGE, "isLogin");

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (!isAuthor) {
    return <>Không có quyền</>;
  }
  return React.cloneElement(children, { ...children.props, pmsAction });
};
PrivateRoute.propTypes = {
  roles: PropTypes.object,
  children: PropTypes.element.isRequired,
};

const ConfigurationMenuList = React.lazy(() =>
  import("../page/ConfigurationMenu/ListPage")
);
const ConfigurationMenuCreate = React.lazy(() =>
  import("../page/ConfigurationMenu/DetailPage")
);
const ConfigDisplaySystemList = React.lazy(() =>
  import("../page/ConfigurationDisplaySystem/ListPage")
);
const ConfigDisplaySystemCreate = React.lazy(() =>
  import("../page/ConfigurationDisplaySystem/DetailPage")
);

export const listRoutesUAA = {
  bizzApp: "UAA",
  listRoute: [
    {
      path: UAA_CHILDREN_PATH.PERMISSION_CONFIG,
      element: <PermissionPage />,
    },
    {
      path: `${UAA_CHILDREN_PATH.PERMISSION_CONFIG}/create`,
      element: <PermissionForm />,
    },
    {
      path: `${UAA_CHILDREN_PATH.PERMISSION_CONFIG}/update/:id`,
      element: <PermissionForm />,
    },
    {
      path: UAA_CHILDREN_PATH.USER_MANAGEMENT,
      element: <UserManagementPage />,
    },
    {
      path: `${UAA_CHILDREN_PATH.USER_MANAGEMENT}/create`,
      element: <CreateUpdateUser />,
    },
    {
      path: `${UAA_CHILDREN_PATH.USER_MANAGEMENT}/update/:id`,
      element: <CreateUpdateUser />,
    },
    {
      path: UAA_CHILDREN_PATH.SYSTEM_MANAGEMENT,
      element: <SystemManagementList />,
    },
    {
      path: `${UAA_CHILDREN_PATH.SYSTEM_MANAGEMENT}/:id`,
      element: <SystemManagementForm />,
    },
    {
      path: `${UAA_CHILDREN_PATH.COMPANY_PERMISSION}`,
      element: <CompanyPermission />,
    },
    {
      path: `${UAA_CHILDREN_PATH.API_MANAGEMENT}`,
      element: <APIManagementList />,
    },
    {
      path: `${UAA_CHILDREN_PATH.API_MANAGEMENT}/create`,
      element: <APIManagementCreate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.API_MANAGEMENT}/:id`,
      element: <APIManagementCreate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.SERVICE}`,
      element: <ServiceManager />,
    },
    {
      path: `${UAA_CHILDREN_PATH.SERVICE}/create`,
      element: <ServiceCreateUpdate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.SERVICE}/update/:id`,
      element: <ServiceCreateUpdate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.FEATURE}`,
      element: <FeatureManager />,
    },
    {
      path: `${UAA_CHILDREN_PATH.FEATURE}/create`,
      element: <FeatureCreateUpdate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.FEATURE}/update/:id`,
      element: <FeatureCreateUpdate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIGURATION_MENU}`,
      element: <ConfigurationMenuList />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIGURATION_MENU}/create`,
      element: <ConfigurationMenuCreate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIGURATION_MENU}/update/:id`,
      element: <ConfigurationMenuCreate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIG_DISPLAY_SYSTEM}`,
      element: <ConfigDisplaySystemList />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIG_DISPLAY_SYSTEM}/create`,
      element: <ConfigDisplaySystemCreate />,
    },
    {
      path: `${UAA_CHILDREN_PATH.CONFIG_DISPLAY_SYSTEM}/update/:id`,
      element: <ConfigDisplaySystemCreate />,
    },
  ],
};

export default PrivateRoute;
